<template>
  <div id="app">
    <Navigation v-if="currentUser"></Navigation>
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<script>
import { mapState } from "vuex";
import Navigation from "./views/Navigation.vue";
export default {
  components: { Navigation },
  computed: {
    ...mapState(["currentUser"])
  }
};
</script>
